export const ADD_VIOLATION_DRAWER_QUERY_KEY = 'addViolation';
